// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"7548fd92","130":"6d944892","140":"bba05348","340":"dc5a8404","649":"f1f242ae","965":"621e26a8","968":"3a9b5e75"}[chunkId] + ".chunk.css";
};